import { render, staticRenderFns } from "./ChartSummaryKabupaten.vue?vue&type=template&id=5840caf5"
import script from "./ChartSummaryKabupaten.vue?vue&type=script&lang=js"
export * from "./ChartSummaryKabupaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports